import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=2cab0f75"
import script from "./AppDownload.vue?vue&type=script&lang=js"
export * from "./AppDownload.vue?vue&type=script&lang=js"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=2cab0f75&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports